module.exports = __webpack_public_path__ + "img/zuijia_23.60c3af4e.png";